import React from 'react';
import { CaseStudyDetail } from '../components/CaseStudyDetail';
import { FeatureVideo } from '../components/FeatureVideo';
import { caseStudies } from '../data/caseStudies';
import { rsiIntro, rsiMetrics, rsiSections } from '../data/rsiCaseStudy';
export function RsiCaseStudy() {
  const card = caseStudies.find(s => s.id === 'rsi');
  const videoSrc = card?.videos?.[0];
  const media = videoSrc && card ? <FeatureVideo src={videoSrc} poster={card.images[0]} background={rsiIntro.background} label="RSI unified inbox walkthrough" data-id="element-153" data-mp="1lp7fly8a7qdn" /> : undefined;
  return <CaseStudyDetail id="rsi" intro={rsiIntro} images={[]} metrics={rsiMetrics} sections={rsiSections} media={media} data-id="element-154" data-mp="1vh4txdul6ygl" />;
}